module.exports = __webpack_public_path__ + "static/media/icono_tache.36e03152.svg";